import { addDays, set, setDayOfYear, startOfYear } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';
import { clock } from '@/services/clock';

interface GetDayMonthOfYearParams {
  dayOfYear: number;
  year?: number;
  hour?: string;
  minute?: string;
  timeZone?: string;
}

export function getDayMonthOfYear({
  dayOfYear,
  year,
  hour,
  minute,
  timeZone
}: GetDayMonthOfYearParams): Date {
  if (year && !Number.isNaN(year)) {
    return createZonedDateFromOrdinal({
      year,
      dayOfYear,
      hour: Number(hour),
      minute: Number(minute),
      timeZone: timeZone ?? 'UTC'
    });
  }
  const startOfYearUTC = fromZonedTime(startOfYear(clock.date()), 'UTC');
  return setDayOfYear(startOfYearUTC, dayOfYear);
}

interface CreateZonedDateFromOrdinalParams {
  year: number;
  dayOfYear: number;
  hour: number;
  minute: number;
  timeZone: string;
}

function createZonedDateFromOrdinal({
  year,
  dayOfYear,
  hour,
  minute,
  timeZone
}: CreateZonedDateFromOrdinalParams): Date {
  const localDate = addDays(startOfYear(new Date(year, 0, 1)), dayOfYear);

  const localWithTime = set(localDate, {
    hours: hour,
    minutes: minute,
    seconds: 0,
    milliseconds: 0
  });

  return fromZonedTime(localWithTime, timeZone);
}
